import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useBluelagoon } from "@bluelagoon";
import { Button } from "@shadcn-in-nx/ui/button";
import { Badge } from "@shadcn-in-nx/ui/badge";
import { Loader2 } from "lucide-react";
import DocGapItem from "./DocGapItem";

export default function DocGapList() {
    const { t } = useTranslation();
    const [gaps, setGaps] = useState([]);
    const [showResolved, setShowResolved] = useState(false);
    const { call: fetchGaps, isLoading } = useBluelagoon({ method: "getDocGaps" });

    const loadGaps = useCallback(async () => {
        const res = await fetchGaps({ resolved: showResolved }).catch(() => null);
        if (res?.data?.docGaps) setGaps(res.data.docGaps);
    }, [fetchGaps, showResolved]);

    useEffect(() => { loadGaps(); }, [loadGaps]);

    const handleUpdate = useCallback((updated) => {
        setGaps((prev) => prev.map((g) => (g.id === updated.id ? { ...g, ...updated } : g)));
    }, []);

    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between">
                <h2 className="text-lg font-semibold">{t("admin.support.docGaps", "Documentation Gaps")}</h2>
                <div className="flex items-center gap-2">
                    <Button variant={showResolved ? "default" : "outline"} size="sm" onClick={() => setShowResolved(!showResolved)}>
                        {showResolved ? t("admin.support.showingResolved", "Showing Resolved") : t("admin.support.showUnresolved", "Unresolved")}
                    </Button>
                    <Badge variant="secondary">{gaps.length}</Badge>
                </div>
            </div>
            {isLoading ? (
                <div className="flex justify-center py-8"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div>
            ) : gaps.length === 0 ? (
                <p className="text-center py-8 text-muted-foreground">{t("admin.support.noDocGaps", "No documentation gaps found")}</p>
            ) : (
                <div className="space-y-2">{gaps.map((gap) => <DocGapItem key={gap.id} gap={gap} onUpdate={handleUpdate} />)}</div>
            )}
        </div>
    );
}
